<template>
  <div class="selectBuyer">
    <div class="select br4" @click="handleClick" >
      <div class="search_box br4">
        <input type="text" placeholder="点击选择买家" :value="value" readonly/>
        <span><i class="iconfont icon-qianwang"></i></span>
        <!-- <span class="icon_search"><i class="iconfont icon-sousuo" style="color:#888"></i></span> -->
      </div>
    </div>
    <md-popup v-model="show" position="right" @show="is_finish= true" >
      <div class="selectBuyer-box">
        <template v-if="is_finish">
          <van-index-bar  :index-list="list_index" :sticky="false">
            <div v-for="(item,key) in list" :key="key" >
              <van-index-anchor :index="key"/>
              <div class="buyer_item" v-for="(item_b,index_b) in item" :key="index_b" @click="handleClickBuyer(item_b)">
                <span class="mand-ellipsis">{{item_b.name}}</span>
                <!-- <span>赊欠：{{item.}}</span>  -->
              </div>
            </div>
          </van-index-bar>
        </template>
      </div>
    </md-popup>
  </div>
</template>

<script>
import { buyer_list } from "@/api/work/open";
export default {
  name: 'selectBuyer',
  model: {
    prop: "value",
    event: "setValue"
  },
  props:{
    value: {
      type: [Array,String],
      default: ""
    },
  },
  watch:{
    
  },
  data(){
    return {
      show:false,
      is_finish:false,
      active:{
        buyer_id:'',
        buyer_name:''
      },
      list:null,
      list_index:[]
      
    }
  },
  
  created(){
  },
  mounted(){
  },
  methods:{
    // 显示
    handleClick(){
      this.getBuyerList()
      this.show = true
    },
    // 获取买家列表
    getBuyerList(){
      buyer_list().then(res=>{
        if(res.code == 200 ){
          // if(res.data.list["#"] && res.data.list["#"].length == 1){
          //   delete res.data.list["#"]
          // }
          this.list = res.data.list
          this.list_index = []
          for (const key in res.data.list) {
            this.list_index.push(key)
          }
        }
      })
    },

    // 点击事件
    handleClickBuyer(item){
      this.$emit("finish",item)
      this.show = false
    }
  },
}
</script>

<style scoped lang="less">
.selectBuyer{
  position: relative;
  width: 100%;
  .select{
    font-size: 0.2rem;
    .search_box{
      width: 100%;
      height: 0.5rem;
      background-color: #e6e6e6;
      padding: 0 0.1rem;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: space-between;
      input{
        line-height: 0.5rem;
        font-size: 0.22rem;
        background-color: #e6e6e6;
      }
      i{
        color: #999;
        font-size: 0.3rem;
      }
    }
  }
  .selectBuyer-box{
    width: 6rem;
    height: 100%;
    overflow: auto;
    font-size: 0.20rem;
    background-color: #fff;
    .buyer_item{
      height: 0.5rem;
      display: flex;
      align-items: center;
      padding: 0 0.2rem;
      padding-right: 0.5rem;
      width: 100%;
      display: flex;
      align-items: center;
    }
  }
}
</style>
<style lang="less">
.selectBuyer{
  .selectBuyer-box{
    .van-index-bar__sidebar{
      span{
        font-size: 0.2rem !important;
        line-height: 0.28rem;
        margin-right: 0.15rem;
      }
    }
    .van-index-bar>div{
      &>div{
        width: 100%;
        line-height: 0.6rem !important;
        border-bottom: 0.01rem solid #f1f1f1;
        &:active{
          background-color: #f5f5f5;
        }
        .van-index-anchor{
          font-size: 0.24rem !important;
          line-height: 0.54rem !important;
          padding: 0 0.2rem;
          background-color: #f1f1f1;
        }
      }
    }
  }
}
</style>
